import loadable from '@loadable/component';
import * as React from 'react';

import LoadingPage from '../../../components/LoadingPage';
import Page from '../../../components/Page';
import { mpTrackingScreens } from '../../../config/screens';

const LoadablePartnerships = loadable(() => import('../containers/Partnerships'), {
    fallback: <LoadingPage isDark />,
});

class LazyLoadPartnerships extends React.Component {
    render() {
        return (
            <Page noCrawl={false} title="Partnerships" trackingScreen={mpTrackingScreens.partnerships}>
                <LoadablePartnerships />
            </Page>
        );
    }
}

export default LazyLoadPartnerships;
